import { InjectedIntl } from 'react-intl'
import { MessageKey } from './types/LanguageLocale'

function getMessage (key: MessageKey, intlProps: InjectedIntl): string {
  return intlProps.messages[key]
}

export default getMessage
